export default function LoadingDots({
  size = 20, // dot diameter in px
  gap = 30, // spacing between dots in px
  color = "#AEE4FF", // base (light sky blue)
  activeColor = "#0B5FFF", // active (deep blue)
  duration = 1500, // one cycle in ms
  label = "로딩 중",
}: {
  size?: number;
  gap?: number;
  color?: string;
  activeColor?: string;
  duration?: number;
  label?: string;
}) {
  const delays = [0, 0.2, 0.4, 0.6]; // seconds

  return (
    <div
      className="flex items-center"
      role="status"
      aria-label={label}
      style={{
        ["--dot-size" as any]: `${size}px`,
        ["--dot-gap" as any]: `${gap}px`,
        ["--dot-color" as any]: color,
        ["--dot-active-color" as any]: activeColor,
        ["--dot-duration" as any]: `${duration}ms`,
      }}
    >
      <div className="flex" style={{ gap: `var(--dot-gap)` }}>
        {delays.map((d, idx) => (
          <span
            key={idx}
            className="dot inline-block rounded-full"
            style={{ animationDelay: `${d}s` }}
          />
        ))}
      </div>

      <style>{`
        .dot {
          width: var(--dot-size);
          height: var(--dot-size);
          background: var(--dot-color);
          transform-origin: center;
          animation: pulseColor var(--dot-duration) ease-in-out infinite;
        }

        @keyframes pulseColor {
          0%, 100% { 
            transform: scale(1); 
            background: var(--dot-color); 
          }
          15% { 
            transform: scale(1.6); 
            background: var(--dot-active-color); 
          }
          30% { 
            transform: scale(1); 
            background: var(--dot-color); 
          }
        }
      `}</style>
    </div>
  );
}
